import { Injectable } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Injectable()
export class ValidationService {
    constructor() {}

    static getValidatorErrorMessage(validatorName: string) {
        let config = {
            required: 'Required',
            oneItemRequired: 'One item is required',
        };

        return config[validatorName];
    }

    static atLeastOneItemSelected(control: UntypedFormControl) {
        if (!control || !control.value) {
            return { oneItemRequired: true };
        }

        if (control.value.filter((x) => x).length > 0) {
            return null;
        }

        return { oneItemRequired: true };
    }

    static greaterThanZeroOrEmpty(control: UntypedFormControl) {
        if (!control || control.value === undefined || control.value === null || control.value === '') {
            return null;
        }

        if (control.value <= 0) {
            return { mustBeGreaterThanZeroOrEmpty: true };
        }

        return null;
    }
}
